import { useMemo } from "react";

import { PROFILE_TIER } from "constants/account";
import { PROCESS_STATUS } from "constants/process";
import { isAboutToExpired as isAboutToExpiredFn } from "helpers/TimeFormatter";
import { IAccount } from "types/account";

import { EddPermissions, KycPermissions, PromotionRequestPermissions, RemediationPermissions } from "./types";

export const getEddPermissions = (user?: IAccount): EddPermissions => {
  const isEDDProcessing =
    user?.edd?.lastStatus === PROCESS_STATUS.draft || user?.edd?.lastStatus === PROCESS_STATUS.pending;

  const isEDDBlocking =
    user?.edd?.currentStatus === PROCESS_STATUS.rejected || user?.edd?.currentStatus === PROCESS_STATUS.expired;

  const isEDDRequired = user?.edd?.lastStatus === PROCESS_STATUS.draft;

  return {
    isEDDProcessing,
    isEDDBlocking,
    isEDDRequired,
  };
};

export const getPromotionRequestPermissions = (user?: IAccount): PromotionRequestPermissions => {
  const isPromotionRequestProcessing =
    user?.promotionRequest?.currentStatus !== null && user?.promotionRequest?.currentStatus !== PROCESS_STATUS.accepted;

  const basePromotionRequestRequired =
    user?.promotionRequest?.currentStatus !== null &&
    user?.promotionRequest?.currentStatus !== PROCESS_STATUS.accepted &&
    user?.promotionRequest?.currentStatus !== PROCESS_STATUS.pending;

  const isBlockedByPromotionRequest = user?.tier === PROFILE_TIER.tier_1_uk_restricted && basePromotionRequestRequired;

  return {
    isPromotionRequestProcessing,
    isBlockedByPromotionRequest,
    basePromotionRequestRequired,
  };
};

export const getKycPermissions = (user?: IAccount): KycPermissions => {
  const isVerificationBlocked = !!user?.verificationBlocked;

  const isKycRejected =
    user?.kyc?.lastStatus !== "pending" &&
    user?.kyc?.lastStatus !== "submitted" &&
    (user?.kyc?.currentStatus === "rejected" || user?.kyc?.previousStatus === "rejected");

  const isKycAboutToExpired = (user?.kyc?.expiresAt &&
    ([PROCESS_STATUS.submitted, PROCESS_STATUS.draft] as string[]).includes(user?.kyc?.lastStatus) &&
    user.kyc?.currentStatus === PROCESS_STATUS.accepted &&
    isAboutToExpiredFn(user.kyc?.expiresAt)) as boolean;

  const isKycExpired =
    user?.kyc?.lastStatus !== "pending" &&
    user?.kyc?.lastStatus !== "submitted" &&
    user?.kyc?.currentStatus === PROCESS_STATUS.expired;

  return {
    isVerificationBlocked,
    isKycRejected,
    isKycAboutToExpired,
    isKycExpired,
  };
};

export const getRemediationPermissions = (user?: IAccount): RemediationPermissions => {
  const isRemediationRequired = user?.virtualAssets?.variant === "remediation";

  return {
    isRemediationRequired,
  };
};
